module.exports = (__webpack_require__(47266))(9792);